<template>
	<div class="c-card">
		<div v-if="index || tag" class="c-card-tag flex-start">
			<div v-if="tag" class="c-card-tag-item">{{tag}}</div>
			<div v-else-if="index" class="c-card-tag-index">{{index}}</div>
		</div>

		<div v-if="removeButton" class="c-card-remove flex-center" @click="$emit('remove')"><i class="tf-trash"></i>移除</div>

		<div v-if="$slots.title" class="c-card-title" :class="{'s-form': $slots.form}">
			<slot name="title"></slot>
		</div>

		<div v-if="$slots.default" class="c-card-content" :class="{'s-form': $slots.form}">
			<slot></slot>
		</div>

		<div v-if="$slots.form" class="c-card-content">
			<slot name="form"></slot>
		</div>

		<div v-if="$slots.list" class="c-card-content">
			<slot name="list"></slot>
		</div>

		<div v-if="addButton" class="c-card-add flex-start-center">
			<template v-if="Array.isArray(addButtonName)">
				<c-link v-for="(item, i) in addButtonName" :key="i" @click="$emit('add', i)"><i class="tf">&#xe63d;</i> {{item}}</c-link>
			</template>
			<c-link v-else @click="$emit('add')"><i class="tf">&#xe63d;</i> {{addButtonName}}</c-link>
		</div>

		<div v-if="$scopedSlots.total || $scopedSlots.button" class="c-card-handle flex-between-center">
			<div class="c-card-total flex-center">
				<slot name="total"></slot>
			</div>
			<div v-if="$scopedSlots.button" class="c-card-button flex-center">
				<slot name="button"></slot>
			</div>
		</div>
		<div v-else style="height: .24rem;"></div>
	</div>
</template>

<script>
	import {createStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'detailCard',

		props: {
			tag: [String, Number],
			index: [String, Number],
			addButton: [Boolean, String, Array],
			removeButton: Boolean
		},

		data() {
			return {
				detailCardStore: createStore({
					updateLabelLength: (len, remove) => {
						if (remove) {
							let index = this.labels.findIndex(item => item == len);
							if (index != -1) {
								this.labels.splice(index, 1);
							}
						} else {
							this.labels.push(len);
						}
					},
					labelLength: 0,
					addButtonName: this.addButton === true ? '添加行' : this.addButton
				}),
				labels: []
			}
		},

		computed: {
			...mapStore('detailCardStore', ['addButtonName']),

			labelLength() {
				return Math.max.apply(Math, this.labels);
			}
		},

		watch: {
			labelLength(val) {
				this.detailCardStore.commit('labelLength', val);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-card {
		position: relative;
		box-sizing: border-box;
		border-radius: .16rem;
		overflow: hidden;
		background: #F9F9F9;

		+ .c-card {
			margin-top: .2rem;
		}

		&-tag {
			padding-bottom: .2rem;

			&-item {
				box-sizing: border-box;
				min-width: .4rem;
				height: .4rem;
				border-radius: .2rem 0 .2rem 0;
				padding: 0 .14rem;
				line-height: .4rem;
				font-size: .26rem;
				text-align: center;
				color: #fff;
				background: #00ACA9;
			}

			&-index {
				box-sizing: border-box;
				min-width: .36rem;
				height: .32rem;
				border-radius: .16rem 0 .16rem 0;
				padding: 0 .1rem;
				line-height: .32rem;
				font-size: .24rem;
				text-align: center;
				color: #0D6EFE;
				background: #E9F2FF;

				&.card-check {
					color: #fff;
					background: var(--color-main);
				}
			}
		}

		&-remove {
			gap: .06rem;
			position: absolute;
			right: 0;
			top: 0;
			height: .48rem;
			border-radius: 0 .16rem 0 .16rem;
			padding: 0 .14rem;
			font-size: .26rem;
			color: #f55;
			background: #F9ECEC;
		}

		&-title {
			padding: 0 .36rem;
			margin-bottom: .14rem;
			font-size: .28rem;
			font-weight: 600;

			&.s-form {
				font-weight: 400;
				color: var(--color-main);
			}
		}

		&-content {
			padding: 0 .24rem;

			&:nth-child(1) {
				padding-top: .24rem;
			}

			+ .c-card-content {
				border-top: 1px solid #eee;
				padding-top: .12rem;
				margin-top: .14rem;
			}

			>>> .c-field {
				padding: .04rem 0;
				margin: 0 .12rem;
				font-size: .26rem;

				&-label {
					color: #666;
				}

				&-content {
					color: #666;
				}

				^[-1].s-form ^[-1..-1] {
					&-label {
						color: #999;
					}

					&-content {
						color: #999;
					}
				}
			}
		}

		&-add {
			gap: .4rem;
			padding: 0 .24rem;
			margin-top: .12rem;

			&:nth-child(1) {
				margin-top: .24rem;
			}

			>>> .c-link {
				line-height: .6rem;
			}
		}

		&-handle {
			height: .75rem;
			border-top: 1px solid #eee;
			margin: .1rem .24rem 0;
		}

		&-total {
			gap: .2rem;
			font-size: .26rem;
			color: #666;
		}

		&-button {
			gap: .2rem;
			font-size: .26rem;
		}
	}
</style>
